import { Box, Typography } from "@mui/material";
import {
  Datagrid,
  List,
  TextField,
  TopToolbar,
  useListContext,
  useRefresh,
  Link,
  useRecordContext,
  downloadCSV,
} from "react-admin"; // eslint-disable-line import/no-unresolved
// import { Link } from "@mui/material";
import useNotify from "../unit/useNotify";
import Button from "@mui/material/Button";
import CustomDateField from "../unit/CustomDateField";
import PostPagination from "../unit/PostPagination";
import getFiltersFromURL from "../unit/getFiltersFromURL";
import CustomLoading from "../unit/CustomLoading";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";
import RequestdataAdd from "./RequestdataAdd";
import RequestdataListAside from "./RequestdataListAside";
import CustomExportButton from "../unit/CustomExportButton";
import { hmLightTheme } from "../themes/hmTheme";
import HmLoading from "../unit/HmLoading";
import NoResults from "../unit/NoResults";
import formatDate from "../unit/formatDate";

const dataRequestTypeExporter = (records: any) => {
  let data = [];
  let title = {};
  const admin = localStorage.getItem("authrole") === "admin";

  data = records.map((record: any) => {
    const { id, sBankName, iApplicationId, sLoanNum, created_at } = record;

    if (admin) {
      return {
        id: id,
        sBankName: admin ? sBankName : undefined,
        iApplicationId: iApplicationId,
        sLoanNum: sLoanNum,
        created_at: formatDate(created_at),
      };
    } else {
      return {
        id: id,
        iApplicationId: iApplicationId,
        sLoanNum: sLoanNum,
        created_at: formatDate(created_at),
      };
    }
  });
  if (admin) {
    title = {
      id: "Req #",
      sBankName: "Institution",
      iApplicationId: "App #",
      sLoanNum: "Loan #",
      created_at: "Request Date",
    };
  } else {
    title = {
      id: "Req #",
      iApplicationId: "App #",
      sLoanNum: "Loan #",
      created_at: "Request Date",
    };
  }
  return {
    title: title,
    data: data,
  };
};

const DataRequestExporter = (records: any) => {
  const filterData = dataRequestTypeExporter(records);
  const currentFilters = getFiltersFromURL();
  let filter_status = currentFilters?.status;
  if (filter_status === "Completed") {
    filter_status = "Closed";
  } else if (filter_status === "Responded") {
    filter_status = "In Progress";
  } else if (filter_status === "New") {
    filter_status = "New";
  }
  let csvTitle = filterData.title;
  let data = filterData.data;
  const csvData = [{ ...csvTitle }, ...data];
  const csvDataStr = csvData.map((row) => Object.values(row).join(","));
  downloadCSV(csvDataStr.join("\n"), "Request Data Change_" + filter_status);
};

const RequestdataList = () => {
  const refresh = useRefresh();
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const CustomRowStyle = (record: any) => {
    if (!record) return {};

    if (record?.sStatus == "Closed") {
      return {
        backgroundColor: "#fff",
        "&.MuiTableRow-hover:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      };
    } else {
      return {
        // backgroundColor: "#ffdb9d30",
        // "&.MuiTableRow-hover:hover": {
        //   backgroundColor: "#ffdb9d60",
        // },
        backgroundColor: "#f5f5f5",
        "& td.MuiTableCell-root": {
          color: "gray",
        },
        "& td.MuiTableCell-root span": {
          color: "gray",
        },
        "& td.MuiTableCell-root a": {
          color: "gray",
        },
        "& td.MuiTableCell-root p": {
          color: "gray",
        },
      };
    }
  };

  const RequestdataAction = (props: any) => {
    return (
      <>
        <TopToolbar sx={{ width: "100%" }}>
          <RequestdataAdd />
          <CustomExportButton />
        </TopToolbar>
      </>
    );
  };
  const LinkRequestIdField = () => {
    const record = useRecordContext();
    if (record == null) {
      return null;
    }
    return (
      <Link
        // component="span"
        to={`/requestdata/${record.id}/show`}
        className="numericText linktext"
        underline="none"
        sx={{
          cursor: "pointer",
          textDecoration: "none",
          "&.RaLink-link": {
            color: "#1976d2",
          },
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        {record.id}
      </Link>
    );
  };

  const authrole = localStorage.getItem("authrole");

  const CustomRequestDataList = () => {
    const listContext = useListContext();
    const { total, data, isPending, isLoading, isFetching } = listContext;

    return (
      <Datagrid
        optimized
        rowClick={false}
        empty={false}
        rowSx={CustomRowStyle}
        // rowClick={handleRowClick}
        size="small"
        id="table-requestdata"
        className="hm-list-datagrid"
        sx={{
          ".MuiTableCell-root": {
            // padding:"6px 16px"
            padding: "6px",
          },
          ".RaDatagrid-headerCell:first-child": {
            borderTopLeftRadius: "0px",
          },
          ".RaDatagrid-headerCell:last-child": {
            borderTopRightRadius: "0px",
          },
          "& .column-groups": {
            md: { display: "none" },
            lg: { display: "table-cell" },
          },
          "& .Mui-active": {
            color: "gray",
          },
          "& .MuiTableSortLabel-root": {
            padding: "5px",
          },
          "& .RaDatagrid-headerCell": {
            color: "gray",
            fontSize: "1rem",
            backgroundColor: "#edf4fb",
            wordWrap: "break-word",
          },
          "& .MuiTableCell-paddingCheckbox": {
            display: "none",
          },
          // sCity ,width:150px
          "& .MuiTableCell-root.column-id": {
            minWidth: "80px",
            width: "80px",
            maxWidth: "80px",
          },
        }}
      >
        {/* <TextField source="id" label="Req #" cellClassName="numericText" /> */}
        <LinkRequestIdField source="id" label="Req #" />
        {authrole === "admin" && (
          <TextField source="sBankName" label="Institution" />
        )}
        <TextField
          source="iApplicationId"
          label="App #"
          cellClassName="numericText"
        />
        <TextField source="sLoanNum" label="Loan #" className="numericText" />
        {/* <TextField source="created_at" label="Request Date" />
         */}
        <CustomDateField
          source="created_at"
          label="Request Date"
          onlyShowDate={true}
          cellClassName="dateText"
        />
        {/* <TextField source="sStatus" label="Status" /> */}
      </Datagrid>
    );
  };
  return (
    <>
      <List
        actions={<RequestdataAction />}
        filters={[]}
        sort={{ field: "created_at", order: "DESC" }}
        aside={<RequestdataListAside selected="requestdata" />}
        exporter={DataRequestExporter}
        sx={{
          width: "100%",
          borderRadius: "0px",
          "& .MuiCard-root": {
            borderRadius: "0px",
          },
          "& .RaList-actions form": {
            flex: "0 1 350%",
          },
          "& .RaList-actions form .filter-field .MuiInputBase-input": {
            width: "230px",
          },
          "& .RaList-actions .RaFilterForm-filterFormInput:first-child .MuiInputBase-root::before":
            {
              display: "none",
            },
          "& .RaList-actions .filter-field:first-child .MuiFormControl-root": {
            marginLeft: 0,
          },
        }}
        empty={
          <Typography className="no-results">
            <NoResults />
          </Typography>
        }
        emptyWhileLoading={false}
        loading={<HmLoading />}
        pagination={<PostPagination />}
        perPage={25}
      >
        <CustomRequestDataList />
        <CustomLoading />
      </List>
    </>
  );
};

export default RequestdataList;
